import {baseRequestService} from "../base.ts";
import {InvitedUser} from "../../types/domain.ts";

export const usersInvitedGet = () => baseRequestService<InvitedUser[]>({
    url: '/users/invited',
    method: 'GET'
})